import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export default makeStyles()((theme) => ({
	filterListItem: {
		padding: `${theme.spacing.small}`,
		borderTop: `1px solid ${theme.palette.neutral['30']}`,

		[getFromBreakpoint('lg')]: {
			border: `1px solid ${theme.palette.neutral['30']}`,
			borderBottom: 'none',

			'&:first-of-type': {
				borderTopLeftRadius: theme.borderRadius.rounded,
				borderTopRightRadius: theme.borderRadius.rounded,
			},

			'&:last-of-type': {
				borderBottom: `1px solid ${theme.palette.neutral['30']}`,
				borderBottomLeftRadius: theme.borderRadius.rounded,
				borderBottomRightRadius: theme.borderRadius.rounded,
			},
		},
	},
	fullWidth: {
		width: '100%',
	},
	durationSelect: {
		marginBottom: theme.spacing.xxsmall,
	},
	listBox: {
		border: 0,
		boxShadow: 'none',
		margin: 0,
		padding: 0,
		gap: theme.spacing.xxsmall,
	},
}));
